import { HttpErrorResponse } from '@angular/common/http';
import { Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { take } from 'rxjs/operators';
import { RecuperarSenhaRequest } from '@shared/models/user/user.model';
import { AcessoService } from '../../services/acesso.service';
import { AppInputComponent } from 'src/app/layout/components/input/input.component';
import { AppButtonComponent } from 'src/app/layout/components/button/button.component';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-forgot-my-password',
  templateUrl: './forgot-my-password.component.html',
  styleUrls: ['./forgot-my-password.component.scss'],
  imports: [
    CommonModule,
    AppInputComponent,
    AppButtonComponent,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
  ],
  standalone: true,
})
export class ForgotMyPasswordComponent implements OnInit, OnDestroy {

  public isLoadingSendMail: boolean = false;
  public hasErrors: boolean = false;
  public forgotMyPasswordForm: UntypedFormGroup;
  public messageType: 'success' | 'error';
  public message: string;
  public showMessage: boolean;
  public isDisabledByTimer: boolean;
  public timeLeftToResendInMs: number = 0;
  private sendAgainTimer: any = null;

  constructor(
    private acessoService: AcessoService,
    private ngZone: NgZone,
  ) {
    this.forgotMyPasswordForm = new UntypedFormGroup({
      email: new UntypedFormControl('', [Validators.required, Validators.email]),
    });
  }

  ngOnInit(): void {
    this.initTimer();
  }

  private initTimer(): void {
    const localStorageMailSend = localStorage.getItem('smart-leiloes-app-recovery-email');
    if (localStorageMailSend && Number(localStorageMailSend) > new Date().getTime()) {
      this.timeLeftToResendInMs = Number(localStorageMailSend) - new Date().getTime();
      this.isDisabledByTimer = true;
      this.ngZone.runOutsideAngular(() => {
        this.sendAgainTimer = setInterval(
          () => this.ngZone.run(() => {
            this.timeLeftToResendInMs -= 1000;
            if (this.timeLeftToResendInMs <= 0) {
              this.isDisabledByTimer = false;
              clearInterval(this.sendAgainTimer);
            }
          }),
          1000,
        );
      });
    }
  }

  sendMail(): void {

    if (!this.forgotMyPasswordForm.valid) return;

    this.isLoadingSendMail = true;

    const recuperarSenhaRequest: RecuperarSenhaRequest = {
      email: this.forgotMyPasswordForm.get('email').value
    }

    this.acessoService.recuperarSenha(recuperarSenhaRequest).pipe( take(1) ).subscribe(
      (res: any) => {
        this.messageType = 'success';
        this.message = 'E-mail enviado com sucesso!';
        localStorage.setItem('smart-leiloes-app-recovery-email', (new Date().getTime() + (59 * 1000)).toString());
        this.initTimer();
        this.isDisabledByTimer = true;
        this.showMessage = true;
        this.isLoadingSendMail = false;
      },
      (err: HttpErrorResponse) => {
        this.messageType = 'error';
        this.message = err.error.message;
        this.showMessage = true;
        this.isLoadingSendMail = false;
      }
    )
  }

  ngOnDestroy(): void {
    if (this.sendAgainTimer) {
      clearInterval(this.sendAgainTimer);
    }
  }

}
